module.exports = __webpack_public_path__ + "static/media/notifications.01823567.svg";